import api from './api';

export interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  is_staff: boolean;
  // Optional extra flags from backend
  user_type?: string;
  is_superuser?: boolean;
  is_premium?: boolean;
  phone?: string | null;
  profile_image?: string | null;
}

export interface LoginResponse {
  access: string;
  refresh: string;
  user: User;
}

export const authService = {
  login: async (username: string, password: string): Promise<LoginResponse> => {
    const response = await api.post('/auth/login/', { username, password });
    const { access, refresh, user } = response.data;
    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);
    return { access, refresh, user };
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  },

  getCurrentUser: async (): Promise<User> => {
    // Backend: backend/backend/urls.py mounts users.urls at /api/auth/
    // users/urls.py exposes profile at /profile/
    const response = await api.get('/auth/profile/');
    return response.data;
  },

  updateProfile: async (data: {
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
  }): Promise<User> => {
    const response = await api.patch('/auth/profile/', data);
    return response.data;
  },

  register: async (
    username: string,
    email: string,
    confirmEmail: string,
    password: string,
    firstName: string,
    lastName: string
  ): Promise<LoginResponse> => {
    // First register the user
    await api.post('/auth/register/', {
      username,
      email,
      confirm_email: confirmEmail,
      password,
      first_name: firstName,
      last_name: lastName,
    });

    // Then login to obtain tokens and user profile
    const loginResponse = await api.post('/auth/login/', { username, password });
    const { access, refresh, user } = loginResponse.data;
    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);
    return { access, refresh, user };
  },
};
